import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { TermsOrGdprResource } from 'app/models/TermsOrGdprResource';

@Injectable()
export class GdprService {

  constructor(private http: HttpClient) { }

  getGdpr(body): Observable<TermsOrGdprResource> {
    return this.http.get<TermsOrGdprResource>(body)
  }


}
